<template>
	<div class="marketplace-row">
		<div>
			<div class="d-flex">
				<!-- platform -->
				<div>
					<img
						v-if="data.platform === 'shopee'"
						src="/images/shopee-icon.svg"
						alt="Shopee"
						width="60"
					/>
					<img
						v-if="data.platform === 'orderonline'"
						src="/images/orderonline.png"
						alt="Orderonlline"
						width="140"
					/>
					<span v-else>
						-
					</span>
				</div>

				<!-- store information -->
				<div v-if="data.shop_label" class="mt-1 ml-2">
					<span class="font-weight-bold">{{ data.shop_label }}</span>
				</div>
			</div>

			<!-- show product -->
			<div>

			</div>

			<!-- sla date -->
			<div v-if="data.ship_by_date" class="d-flex">
				<div :class="[isExpired ? 'text-danger font-weight-bold' : 'marketplace-sla-countdown']" class="mt-1">
					{{ isExpired ? 'Waktu Habis' : `${countHours} : ${countMinutes} : ${countSeconds}` }}
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { mapGetters } from 'vuex';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
// eslint-disable-next-line import/no-unresolved
// import duration from 'dayjs/plugin/duration';
import 'dayjs/locale/id';

dayjs.extend(utc);

export default {
	name: 'MarketplaceColumn',
	props: {
		data: {
			type: Object,
			default: () => ({}),
		},
	},
	data() {
		return {
			sla_date: null,
			countDays: 0,
			countHours: 0,
			countMinutes: 0,
			countSeconds: 0,
			isExpired: false,
		};
	},
	computed: {
		...mapGetters({
			isAdmin: 'isAdmin',
		}),
		marketplaceData() {
			return this?.data || {};
		},
	},
	created() {
		this.countSlaDate();
	},
	methods: {
		countSlaDate() {
			if (this.data && this.data.ship_by_date) {
				const slaDate = dayjs.unix(this.data.ship_by_date);
				let formattedDate = dayjs(slaDate).format('YYYY-MM-DD HH:mm:ss');
				formattedDate = dayjs(formattedDate).locale('id');
				const converDeadlineDate = new Date(formattedDate).getTime();

				const deadline = converDeadlineDate;
				// const initialDate = deadline - new Date().getTime();

				// count interval
				setInterval(() => {
					const now = new Date().getTime();
					const distance = deadline - now;
					const _second = 1000;
					const _minute = _second * 60;
					const _hour = _minute * 60;
					const _day = _hour * 24;

					// const days = Math.floor(distance / _day);
					const hours = Math.floor((distance % _day) / _hour);
					const minutes = Math.floor((distance % _hour) / _minute);
					const seconds = Math.floor((distance % _minute) / _second);


					this.countHours = hours;
					this.countMinutes = minutes;
					this.countSeconds = seconds;

					if (distance < 0 || (this.countHours <= 0 && this.countMinutes <= 0 && this.countSeconds <= 0)) {
						this.isExpired = true;
					}
				}, 10);
			}
		},
	},
};
</script>

<style lang="scss" scoped>
.marketplace-row {
	width: 200px;
}
.marketplace-sla-countdown {
	padding: 1px 5px;
	font-size: 12px;
	font-weight: 600;
	color: #17a2b8;
	background: #afe8f1;
	border: 1px solid #afe8f1;
	border-radius: 3px;
	text-align: center;
}
</style>
